import { type Row } from "@tanstack/react-table";
import { RoutePath } from "src/routes";
import { RoutePathParams } from "src/utils/buildUrl";

import { ContextMenuItem } from "../../ContextMenu";
import LoadingRow from "../LoadingRow";
import TableRow from "../TableRow";

import styles from "./TableBody.module.scss";

export interface TableBodyProps<Data> {
    rows: Row<Data>[];
    isLoading?: boolean;
    getRowHref?: (row: Row<Data>) => RoutePathParams<RoutePath>;
    onRowClick?: (row: Row<Data>) => void;
    onRowDoubleClickCapture?: (row: Row<Data>) => void;
    getCellStyles?: ({ row, column }: { row: Row<Data>; column: { id: string } }) => string[];
    getContextMenuItems?: (row: Row<Data>) => ContextMenuItem[];
    showContextMenu: (
        menuFn: (onClose: () => void) => JSX.Element,
        config?: Record<string, unknown>
    ) => (event: React.MouseEvent) => void;
}

const TableBody = <Data extends object>({
    rows,
    isLoading,
    getRowHref,
    onRowClick,
    onRowDoubleClickCapture,
    getCellStyles,
    getContextMenuItems,
    showContextMenu,
}: TableBodyProps<Data>) => {
    return (
        <tbody className={styles.tbody}>
            {isLoading && <LoadingRow colSpan={100} />}
            {rows.map((row, index) => (
                <TableRow
                    key={`${index}${row.id}`}
                    row={row}
                    index={index}
                    getRowHref={getRowHref}
                    onRowClick={onRowClick}
                    onRowDoubleClickCapture={onRowDoubleClickCapture}
                    getCellStyles={getCellStyles}
                    getContextMenuItems={getContextMenuItems}
                    showContextMenu={showContextMenu}
                />
            ))}
        </tbody>
    );
};

export default TableBody;
